module.exports = __webpack_public_path__ + "static/media/LA Function 2024 promo IG 2.3ede2f62.MOV";